import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';

const sendClerkClickEvent = async (productId: string) => {
  await apiRequest(
    endpoints.clerkV1Click,
    {
      productId,
    },
    'POST',
    'data',
  );
};

export default sendClerkClickEvent;
